import type { FaireProductEntity } from "../../entity_types/product";

export const p_avtw6yph: FaireProductEntity = {
  token: "p_avtw6yph",
  type: "product",
  name: "Peace Comfort Strength Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6aad99feec039ab58eb0596ef8151344b4e924c2d5f71df8b6e983f0aeee96fa/1528347335.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/fd45c2fe3c2ebd3273a05a5dc25885eb4d90983362d56a768e90a830a111d349/1528347334.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:20.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
